import { ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { ClientContactCreateOrEditDto, ClientCreateOrEditDto, ClientDto, ClientServiceProxy, ClientType, ClientType2, ClientType3, CommonCacheServiceProxy, CompanyProfileCountryLookupTableDto, CompanyProfileServiceProxy, CreateEditionDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { Workbook } from 'exceljs';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import * as fs from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ModalDeletePopupComponent } from '@app/shared/common/modal-popup/modal-delete-popup/modal-delete-popup.component';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AbpSessionService, MessageService, } from 'abp-ng2-module';
import { ToastrService } from 'ngx-toastr';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ModalPopupComponent } from '@app/shared/common/modal-popup/modal-popup/modal-popup.component';
import * as _ from 'lodash';
import { ClientService } from './Service/client.service';
import * as xlsx from "xlsx-js-style";
import { ClientDropServiceService } from '@app/shared/layout/themes/default/client-drop-service.service';
import { ClientNameService } from '@app/shared/layout/themes/default/client-name.service';
import { DefaultLayoutService } from '@app/shared/layout/themes/default/default-layout.service';
import { UsersDateFormatService } from '@shared/common/dateTimeFormat/date-format.service';
import { DatePipe } from '@angular/common';
import { AppConsts } from '@shared/AppConsts';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { Exception, SeverityLevel } from '@microsoft/applicationinsights-web';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';
import { DxDataGridComponent } from 'devextreme-angular';
import moment from 'moment';

const FileSaver = require("file-saver");
//import { DefaultLayoutService } from './default-layout.service';

@Component({
    selector: 'app-client-new',
    templateUrl: './client-new.component.html',
    styleUrls: ['./client-new.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ClientNewComponent extends AppComponentBase implements OnInit {
    pipe = new DatePipe('en-US');
    @ViewChild("appModaldeletePopup") appModaldeletePopup: ModalDeletePopupComponent;
    @ViewChild("appModaldeletePopup") appModaldeletePopup2: ModalDeletePopupComponent;
    @ViewChild("appModalPopup") appModalPopup: ModalPopupComponent;
    @ViewChild("clientTabs", { static: false }) clientTabs: TabsetComponent;
    @ViewChild("appChangeRouteModalPopup") appChangeRouteModalPopup: ModalPopupComponent;
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    @Input() countryId: number;

    isLoading: boolean = true;
    isRecentlyUpdatedLoading: boolean = true;
    clientsCards = [
        { id: 0, name: 'Overdue', price: '$0', point: '00', icon: 'assets/common/images/clients/overdue.svg', class: 'text-red' },
        { id: 1, name: 'Total Outstanding', price: '$0', point: '00', icon: 'assets/common/images/clients/totalOutstanding.svg', class: 'text-info' },
        { id: 2, name: 'In Draft', price: '$0', point: '00', icon: 'assets/common/images/clients/inDraft.svg', class: 'text-grey' }
    ];
    allCountry: CompanyProfileCountryLookupTableDto[] = [];
    latestClients: ClientDto[];
    clientDto: ClientDto[];
    flagselected: string = '';
    recentlyUpdatedClientOne: ClientDto[] = [];
    uparrow = true;
    dateFormat = 'dd/MM/yyyy';
    uparrow1 = true;
    clientType: ClientType2;
    clientSelectedType = 'Active';
    selectedClients: ClientDto[];
    exportClients: ClientDto[];
    filterText = '';
    clientData: ClientDto[];
    clientInfo: ClientCreateOrEditDto[];
    clientFilterData: ClientDto[] = [];
    singleDeleteid: number;
    singleDelete = false;
    clintEditOption: number;
    clientIdEdit: number;
    clientsExcelDataArray: any;
    data = [];
    head: any;
    clientExcelDataArray: any;
    recentUpdates: ClientDto[];
    isHideExport: boolean = false;
    allowmultipledelete: boolean = false;
    singledeleteFromarchive = false;
    recentclientdelete = false;
    singledeleteFromarchiveId: number;
    recentclientdeleteId: number;
    showEmptyStateForRecentClients = false;
    IsClientsDataEmpty = false;
    singlePermanentDeleteId: number;
    IsSinglePermanentDelete = false;
    isVisible: boolean = true;
    imagePath = '';
    diDate = 1;
    clientName: CreateEditionDto;
    newClientTabs: number[] = [];
    isSidebarOpen = false;
    tempData: ClientDto[];
    dateTime = new Date();
    msg: string;
    clientContactData: ClientContactCreateOrEditDto[] = [];
    primaryContactData = new ClientContactCreateOrEditDto();
    primaryContactList: ClientContactCreateOrEditDto[] = [];
    secondaryContactData = new ClientContactCreateOrEditDto();
    secondaryContactList: ClientContactCreateOrEditDto[] = [];
    show: boolean;
    showClientExport: boolean = false;
    clientDetailsForFilter: any[] = [];
    isarchived: boolean = false;
    isrestored: boolean = false;
    restoreBunchFromArchived: boolean = false;
    restoreBunchFromDeleted: boolean = false;
    deleteBunchFromArchived: boolean = false;

    constructor(injector: Injector, public router: Router, private headerTitleService: HeaderTitleService,
        private _companyProfilesServiceProxy: CompanyProfileServiceProxy,
        private _spinnerService: NgxSpinnerService,
        private _companyProfileServiceProxy: CompanyProfileServiceProxy,
        private _client_drop_service: ClientDropServiceService,
        private _clientNameService: ClientNameService,
        private _userServiceProxy: UserServiceProxy,
        private _usersDateFormatService: UsersDateFormatService,
        private _abpSessionService: AbpSessionService,
        private toastr: ToastrService,
        private _messageService: MessageService,
        private _clientServiceProxy: ClientServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _clientService: ClientService,
        private cdRef: ChangeDetectorRef,
        private _defaultLayoutService: DefaultLayoutService,
        private monitorService: MonitoringService,
        private _commonCacheServiceProxy: CommonCacheServiceProxy,
    ) {

        super(injector);
    }
    getClientResponse() {
        this._defaultLayoutService.showType.subscribe((res: any) => {
            this.openSelectedTab(res);
        }
        )
    }

    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this.monitorService.logPageView("UI-Clinet_new", this.router.url);
        // this.getCompanyProfile();
        if (this.countryId)
            this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.flag });

        // abp.event.on('getClientResponse', () => { this.getClientResponse(); });

        this.getOtherSettingForShowAndHidePermissionUserWise();
        this.setBreadcrum('');
        this.clientType = ClientType2.AllClients;
        let x = this. _activatedRoute.snapshot.queryParams.id;
        x = x ? Number(x) : 1;
        this.openSelectedTab(x);
        this._defaultLayoutService.selectedTabForClient(x);
        // this.getAllClients();
        this.recendaryUpdateClient();
        this.isVisible = true;
        this.getDateFormat();
        // this.getFilterByClientDetails()
    }
    ngOnChanges() {
        if (this.countryId)
            this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.flag });
        else
            this.flagselected = '';
    }

    getCompanyProfile() {
        this.monitorService.logTrace("UI-GetCompanyProfile", { "GetCompanyProfile ": "start: " + this + this.dateTime + "InputData:" + null }, SeverityLevel.Information)
        this.monitorService.logEvent("GetCompanyProfileEvent", { "GetCompanyProfile": "start: " + this.msg });
        try {
            this._companyProfilesServiceProxy.getAllCountryForTableDropdown().subscribe(result => {
                this.allCountry = result.filter((country) => {
                    return country.displayName !== '';
                }).sort((a, b) => a.displayName.localeCompare(b.displayName));
                this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.flag });
                this.monitorService.logEvent("GetCompanyProfileEvent", { "GetCompanyProfile": "completed: " + this.msg + this.dateTime });
            });
        }
        catch (ex: any) {
            this.monitorService.logException(ex, 2);
        }
    }

    getDateFormat() {
        if (AppConsts.dateFormatId) {
            this.dateFormat = AppConsts.dateFormatList.find(r => r.id === AppConsts.dateFormatId).name;
            this.dateFormat = this.dateFormat.toUpperCase().replace('DD', 'dd').replace('YYYY', 'yyyy');
        }
    }
    //For confirm leave form guard
    shouldConfirmBeforeLeavingComponent() {

        if (this.newClientTabs.length < 1) {
            return false;
        } else {
            return true;
        }

    }

    //For confirm leave form guard
    changeRoute: any;
    changeRouteResolve: any;
    changeRouteReject: any;


    async showChangeRouteModal() {
        var component = this;

        return new Promise<boolean>((resolve, reject) => {
            this.spinnerService.hide();
            this.appChangeRouteModalPopup.show(2);
            this.clientTabs.tabs[1].active = true;
            component.changeRouteResolve = resolve;
            component.changeRouteReject = reject;
        });
    }

    changeRouteModalYes(event) {
        this.changeRouteResolve(true);
    }

    changeRouteModalCancel() {
        this.changeRouteResolve(false);
    }


     getDateFormatExport() {
        let dateFormat = "dd/MM/yyyy"; // Default date format
        if (AppConsts.dateFormatId) {
            const selectedDateFormat = AppConsts.dateFormatList.find((r) => r.id === AppConsts.dateFormatId);
            if (selectedDateFormat) {
                dateFormat = selectedDateFormat.name;
            }
        }
        return dateFormat;
    }


    setBreadcrum(event: string) {
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem("Clients  |"),
            // new BreadcrumbItem('All Clients')
        ]));
    }

    closeTab(event?: Event) {
        this.monitorService.logEvent("CloseTab", { "CloseTab": "start: " + this.msg });

        this.isVisible = true;
        if (event) event.stopPropagation();
        this.newClientTabs = [];
        this.clientTabs.tabs[0].active = true;
        this.clientSelectedType = 'Active';
        this.clientType = ClientType2.AllClients;
        this.getAllClients();
        this.recendaryUpdateClient();
        this.setBreadcrum('');
        this.monitorService.logEvent("CloseTab", { "CloseTab": "completed: " + this.msg });
    }

    closeTabWithPopUp() {
        this.appModalPopup.show(2);
    }
    //
    // Get User Wise Hide Setting Setted From Setting -> User -> UserWiseSetting -> Other Setting
    //
    getOtherSettingForShowAndHidePermissionUserWise() {
        if (!AppConsts.userSettings) {
            this._commonCacheServiceProxy.getUserTrackOtherSettingForEdit(this._abpSessionService.tenantId, this._abpSessionService.userId).subscribe(x => {
                this.isHideExport = x?.isExptSec === true; AppConsts.userSettings = x;
            });
        } else { this.isHideExport = AppConsts.userSettings?.isExptSec === true; }
    }

    redirectToClientDetails() {
        this.monitorService.logEvent("redirectToClientDetails", { "redirectToClientDetails": "start: " + this.msg + this.dateTime });

        this.router.navigate(['/app/main/client-new/clients-details']);
        this.monitorService.logEvent("redirectToClientDetails", { "redirectToClientDetails": "completed: " + this.msg + this.dateTime });
    }


    clientoredit(ClientType: number) {


        // this.clientType = ClientType
        // if (this. newClientTabs.length < 1){

        // this. newClientTabs.push(1)
        // }

        // this.isVisible=false;
        // //this.projectsTabs.tabs[1].active = true;
        // setTimeout(() => {
        //   this. clientTabs.tabs[1].active = true;

        // });
        this.clientType = 1

        this.router.navigate(['/app/main/client-new/create-or-edit-client']);
    }

    recendaryUpdateClient() {
        this.isRecentlyUpdatedLoading = true;
        this._clientServiceProxy.recendaryUpdateClient().subscribe(result => {
            this.recentUpdates = result;
            this.latestClients = [];
            this.isRecentlyUpdatedLoading = false;
            result.reverse().forEach(c => {
                if (this.latestClients.length <= 3) {
                    this.latestClients.push(c);
                }
            });
            this.latestClients.length ? this.showEmptyStateForRecentClients = false : this.showEmptyStateForRecentClients = true;
            this.cdRef.detectChanges();
            this.recentlyUpdatedClientOne = this.latestClients.length ? [this.latestClients[0]] : [];
        });
    }

    viewRecentClient(client: ClientDto) {
        this.monitorService.logTrace("UI-viewRecentClient", { "viewRecentClient ": "navigated:/app/main/client-new/view-selected-client-details " + this.msg + this.dateTime }, SeverityLevel.Information)
        if (this.clientType === ClientType2.DeletedClients) return;
        this.clientIdEdit = client.id;
        this.clintEditOption = 2;
        this.router.navigate(['/app/main/client-new/view-selected-client-details'], { state: { ClientId: this.clientIdEdit, option: this.clintEditOption } });

    }

    deleteRecentClient(client: ClientDto) {
        this.singleDeleteid = client.id;
        this.deleteClientEvent(this.singleDeleteid);
    }

    editRecentClient(client: ClientDto) {
        this.clientIdEdit = client.id;
        this.clintEditOption = 1;
        this.router.navigate(['/app/main/client-new/create-or-edit-client'], { state: { ClientId: this.clientIdEdit, option: this.clintEditOption } });
    }

    deleteClientEvent(clientId: number) {
        this.monitorService.logEvent("UI-deleteClientEvent", { "deleteClientEvent": "Start: " + this.dateTime });
        this.recentclientdeleteId = clientId;
        this.recentclientdelete = true;
        this.appModaldeletePopup.show()
        this.monitorService.logEvent("UI-deleteClientEvent", { "deleteClientEvent": "Completed: " + this.dateTime });
    }

    openSelectedTab(value: number) {
        if (value === 1) {
            this.clientType = ClientType2.AllClients;
            this.clientSelectedType = 'Active';
        }
        if (value === 2) {
            this.clientType = ClientType2.ArchivedClients;
            this.clientSelectedType = 'Archived';
        }
        if (value === 3) {
            this.clientType = ClientType2.DeletedClients;
            this.clientSelectedType = 'Deleted';
        }

        if (this.filterText) {
            this.getFilterClients();
        }
        else {
            this.getAllClients();
        }
    }

    getFilterByClientDetails() {
        try {
            this.monitorService.logEvent("UI-getFilterByClientDetails", { "getFilterByClientDetails": "Start: " + this.msg + this.dateTime });
            this._clientServiceProxy.getClientByName(this.filterText, ClientType3.TotalClients).pipe(finalize(() => { this.isLoading = false; this._spinnerService.hide(); })).subscribe(res => {
                this.clientFilterData = res;
                if (this.filterText == "" && !this.filterText) {
                    this.getAllClients()
                }
                this.monitorService.logEvent("UI-getFilterByClientDetails", { "getFilterByClientDetails": "Completed: " + this.dateTime });
                // this.IsClientsDataEmpty = this.clientData.length ? false : true;
            });
        }
        catch (ex: any) {
            this.monitorService.logException(ex, 2);
        }
    }

    getAllClients() {
        this.monitorService.logTrace("UI-getAllClients", { "getAllClients ": "start: " + this.msg + this.dateTime + "InputData:clientType=" + this.clientType }, SeverityLevel.Information)
        this.selectedClients = [];
        this.isLoading = true;
        this._spinnerService.show();
        this._clientServiceProxy.getAllClients(this.clientType).pipe(finalize(() => { this.isLoading = false; this._spinnerService.hide(); })).subscribe(res => {
            this.clientData = [];
            res.map(x => {
                x['primaryContractEmail'] = this.getPrimaryContact(x) + x.contactDetails?.email;
                if (x.contactDetails?.clientContactRoleId === 1) {
                    x['BillingContactData'] = this.getSecondaryContact(x) + this.getSecondaryEmail(x);
                    x['TechnicalContactData'] = this.getPrimaryContact(x) + this.getPrimaryEmail(x);
                } else if (x.contactDetails?.clientContactRoleId === 2) {
                    x['BillingContactData'] = this.getPrimaryContact(x) + this.getPrimaryEmail(x);
                    x['TechnicalContactData'] = this.getSecondaryContact(x) + this.getSecondaryEmail(x);
                }

            });
            this.clientData = res;
            this.clientDetailsForFilter = res;
            this.tempData = res;
            this.IsClientsDataEmpty = this.clientData.length ? false : true;
            this.isLoading = false;
        });
        this.monitorService.logTrace("UI-getAllClients", { "getAllClients ": "Completed: " + this.msg + this.dateTime }, SeverityLevel.Information)

    }

    getFilterClients() {
        this.selectedClients = [];
        this.isLoading = true;
        //this._spinnerService.show();
        if (this.clientType === ClientType2.AllClients) {
            // this._clientServiceProxy.getClientByName(this.filterText, ClientType.AllClients).pipe(finalize(() => { this.isLoading = false; this._spinnerService.hide(); })).subscribe(res => {
            //     this.clientData = res;
            //     this.IsClientsDataEmpty = this.clientData.length ? false : true;
            // });
            this.clientData = this.clientFilterData.filter(x => x.clientTypeDetails == ClientType.AllClients);
            this.checkIfContains();
            this.IsClientsDataEmpty = this.clientData.length ? false : true;
        } else if (this.clientType === ClientType2.ArchivedClients) {
            // this._clientServiceProxy.getClientByName(this.filterText, ClientType.ArchivedClients).pipe(finalize(() => { this.isLoading = false; this._spinnerService.hide(); })).subscribe(res => {
            this.clientData = this.clientFilterData.filter(x => x.clientTypeDetails == ClientType.ArchivedClients);
            this.checkIfContains();
            this.IsClientsDataEmpty = this.clientData.length ? false : true;
            // });
        } else if (this.clientType === ClientType2.DeletedClients) {
            // this._clientServiceProxy.getClientByName(this.filterText, ClientType.DeletedClients).pipe(finalize(() => { this.isLoading = false; this._spinnerService.hide(); })).subscribe(res => {
            this.clientData = this.clientFilterData.filter(x => x.clientTypeDetails == ClientType.DeletedClients);
            this.checkIfContains();
            this.IsClientsDataEmpty = this.clientData.length ? false : true;
            // });
        }
    }

    checkIfContains() {
        let tempData1 = [];
        this.clientData = this.clientDetailsForFilter;
        this.clientData.forEach(x => {
            if (x.name.toLowerCase().includes(this.filterText.toLowerCase())) {
                tempData1.push(x);
            }
            let fullName = this.getPrimaryContact(x);
            if (fullName.toLowerCase().includes(this.filterText.toLowerCase())) {
                if (!tempData1.includes(x)) {
                    tempData1.push(x);
                }
            }
        });
        this.clientData = [];

        this.clientData = tempData1;
        if (this.clientData) {
            this.isLoading = false;
        }
    }

    archiveBunchFromAllClients() {
        let temp: number[] = [];
        this.isarchived = true;
        if (this.selectedClients.length === 0) {
            this._messageService.warn(this.l("PleaseSelectClients"))
            this.isarchived = false;
            return;
        }
        this.selectedClients.forEach(x => { temp.push(x.id) });
        this._clientServiceProxy.archiveClientByList(temp).subscribe(() => {
            this.getAllClients();
            this.toastr.success(this.l("Archievedsuccessfully"),'', {
                toastClass: 'custom-width-toastr'
              });
            this.isarchived = false;
            //this.notify.success("Archieved Successfully", "Archieved !!");
        });
    }

    deleteBunchFromAllClients() {

        if (this.selectedClients.length === 0) {
            this._messageService.warn(this.l("PleaseSelectClients"))
            return;
        }
        this.allowmultipledelete = true;
        this.appModaldeletePopup.show();
    }
    onModalYesClick2(id) {

        let temp: number[] = [];
        this.selectedClients.forEach(x => { temp.push(x.id) });
        this._clientServiceProxy.deleteClientByList(temp).subscribe(() => {
            this.getAllClients();
        });
    }

    unarchiveBunchFromArchivedClients() {
        let temp: number[] = [];
        this.isrestored = false;
        this.restoreBunchFromArchived = true;
        if (this.selectedClients.length === 0) {
            this._messageService.warn(this.l("PleaseSelectClients"))
            this.isrestored = true;
            this.restoreBunchFromArchived = false;
            return;
        }
        this.selectedClients.forEach(x => { temp.push(x.id) });
        this._clientServiceProxy.unArchiveClinetByList(temp).subscribe(() => {
            this.getAllClients();
            this.toastr.success(this.l("Restoredsuccessfully"),'', {
                toastClass: 'custom-width-toastr'
              });
            this.isrestored = true;
            this.restoreBunchFromArchived = false;
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    deleteBunchFromArchivedClients() {
        this.monitorService.logTrace("UI-GetCompanyProfile", { "GetCompanyProfile ": "start: " + this.msg + this.dateTime + "InputData:" + null }, SeverityLevel.Information)
        let temp: number[] = [];
        this.deleteBunchFromArchived = true;
        if (this.selectedClients.length === 0) {
            this._messageService.warn(this.l("PleaseSelectClients"))
            this.deleteBunchFromArchived = false;
            return;
        }
        this.allowmultipledelete = true;
        this.appModaldeletePopup.show();
    }

    undeleteBunchFromDeletedClients() {
        let temp: number[] = [];
        this.restoreBunchFromDeleted = true;
        if (this.selectedClients.length === 0) {
            this._messageService.warn(this.l("PleaseSelectClients"))
            this.restoreBunchFromDeleted = false;
            return;
        }
        this.selectedClients.forEach(x => { temp.push(x.id) });
        this._clientServiceProxy.unDeleteClientByList(temp).subscribe(() => {
            this.getAllClients();
            this.toastr.success(this.l("Restoredsuccessfully"),'', {
                toastClass: 'custom-width-toastr'
              });
            this.restoreBunchFromDeleted = false;
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    permanantDeleteBunchFromDeletedClients() {
        this.monitorService.logTrace("UI-permanantDeleteBunchFromDeletedClients", { "permanantDeleteBunchFromDeletedClients ": "start: " + this.msg + this.dateTime }, SeverityLevel.Information)
        try {
            let temp: number[] = [];
            if (this.selectedClients.length === 0) {
                this._messageService.warn(this.l("PleaseSelectClients"))
                return;
            }
            this.selectedClients.forEach(x => { temp.push(x.id) });
            this._clientServiceProxy.permanantDeleteClientByList(temp).subscribe(() => {
                this.getAllClients();
                this.toastr.error(this.l("Deleted successfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
                this.monitorService.logTrace("UI-permanantDeleteBunchFromDeletedClients", { "permanantDeleteBunchFromDeletedClients ": "Completed: " + this.msg + this.dateTime }, SeverityLevel.Information)
            });
        }
        catch (ex: any) {
            this.monitorService.logException(ex, 2);
        }

    }

    singlePermanentDelete(id: number) {
        this.singlePermanentDeleteId = id;
        this.IsSinglePermanentDelete = true;
        this.appModaldeletePopup.show();
    }

    editClient(id: number) {
        this.monitorService.logTrace("UI-editClient", { "editClient ": "redirect" + this.msg + this.dateTime }, SeverityLevel.Information)
        this.clientIdEdit = id;
        this.clintEditOption = 2;
        this.router.navigate(['/app/main/client-new/create-or-edit-client'], { state: { ClientId: this.clientIdEdit, option: this.clintEditOption } });
    }



    singleArchiveClient(id: number) {
        this._clientServiceProxy.updateStatusClientArchive(id).subscribe(() => {
            this.getAllClients();
            this.toastr.success(this.l("Archievedsuccessfully"), '', {
                toastClass: 'custom-width-toastr'
              });
            //this.notify.success("Archived Successfully", "Archived !!");
        });

    }

    singledeletedClient(id: number, myDrop) {
        myDrop.close();
        this.singledeleteFromarchive = true;
        this.singledeleteFromarchiveId = id;
        this.appModaldeletePopup.show();
    }

    singleUnarchiveClient(id: number) {
        this.monitorService.logTrace("UI-singleUnarchiveClient", { "singleUnarchiveClient ": "updateStatusClientUnArchive called: " + this.msg + this.dateTime }, SeverityLevel.Information)

        this._clientServiceProxy.updateStatusClientUnArchive(id).subscribe(() => {
            this.getAllClients();
            this.toastr.success(this.l("Restoredsuccessfully"),'', {
                toastClass: 'custom-width-toastr'
              });
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    singleUnDeleteFromAllDeleted(id: number) {
        this.monitorService.logTrace("UI-singleUnDeleteFromAllDeleted", { "singleUnDeleteFromAllDeleted ": "updateStatusClientUnDelete called: " + this.msg + this.dateTime }, SeverityLevel.Information)
        this._clientServiceProxy.updateStatusClientUnDelete(id).subscribe(() => {
            this.getAllClients();
            this.toastr.success(this.l("Restoredsuccessfully"),'', {
                toastClass: 'custom-width-toastr'
              });
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    singlePermantDeleteFromAllDeleted(id: number) {
        this.monitorService.logTrace("UI-singlePermantDeleteFromAllDeleted", { "singlePermantDeleteFromAllDeleted ": "deleteClientByList called: " + this.msg + this.dateTime }, SeverityLevel.Information)

        this._clientServiceProxy.deleteClientByList([id]).subscribe(() => {
            this.getAllClients();
            this.toastr.error(this.l("Deleted successfully"));
            //this.notify.success("Deleted Successfully", "Deleted !!");
        });
    }

    //export to pdf/excel functions
    onExporting(e) {
        if (e.format == 'pdf') {
            this.exportGrid();
        }
        else {
            this.exportClientListToExcel();
            return;
            const title = 'Clients List';
            const header = ['Client Name', 'Primary Contact', 'Billing Contact', 'Technical Contact', 'Country', 'Active Projects', 'Onboarded on'];
            this.clientsExcelDataArray = [];
            this.clientData.forEach(x => {

                this.data = [x.name, x.contactDetailsInString, x.clientContactDetails.clientContactRoleId, x.clientContactDetails.clientContactRoleId, x.country.name, x.projectCount, x.orgnizationCreationDate];
                this.clientsExcelDataArray.push(this.data);
            });
            let workbook = new Workbook();
            let worksheet = workbook.addWorksheet('Clients');
            worksheet.addRow([]);
            worksheet.addRow(header);
            this.clientsExcelDataArray.forEach(d => {
                worksheet.addRow(d);
            }
            );
            workbook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fs.saveAs(blob, title + '.xlsx');
            });
        }

    }
    exportClientListToExcel(selectedItems = []) {
        this.monitorService.logTrace("UI-exportClientListToExcel", { "exportClientListToExcel ": "Start: " + this.msg + this.dateTime }, SeverityLevel.Information)
        try {
            this.dataGrid.instance.getDataSource()?.store()
            .load({ filter: this.dataGrid.instance.getCombinedFilter(true), sort: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.sort, group: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.group })
            .then((filteredData: any) => {
                const workbook: xlsx.WorkBook = xlsx.utils.book_new();
                const worksheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
                let clientContactRole;
                xlsx.utils.sheet_add_aoa(
                    worksheet,
                    [[this.clientSelectedType + ' Clients List']],
                    {
                        origin: "A1",
                    }
                );
                xlsx.utils.sheet_add_aoa(
                    worksheet,
                    [['Client Name', 'Primary Contact', 'Billing Contact', 'Technical Contact', 'Country', 'Active Projects', 'Onboarded on']],
                    {
                        origin: "A3",
                    }
                );
                // let filterUsers = this.dataGrid.instance.getDataSource();
                // let filteredData = filterUsers.items();
                this.clientData = [];
                // this.clientData = filteredData;
                worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
                selectedItems.length == 0 ? this.clientData = filteredData :  this.clientData = selectedItems;
                let formattedDate;
                let data = this.clientData.map((x) => {

                    if (this.dateFormat == 'dd/MM/yyyy') {
                        formattedDate = moment(new Date(x.orgnizationCreationDate.toString())).format("DD MMM YYYY")
                    }
                    else if (this.dateFormat == 'MM/dd/yyyy') {
                        formattedDate = moment(new Date(x.orgnizationCreationDate.toString())).format("MMM DD YYYY")

                    }
                    else {
                        formattedDate = moment(new Date(x.orgnizationCreationDate.toString())).format("YYYY DD MMM")
                    }
                    let formattedCreationTime = new Date(formattedDate as any);
                    let arr = [x.name, this.getPrimaryContact(x), this.getTechnicalContact(x), this.getBillingContact(x), x.country.name, x.projectCount, formattedCreationTime];
                    return arr;
                });
                xlsx.utils.sheet_add_aoa(worksheet, data, { origin: "A4" });
                worksheet["!cols"] = [
                    { width: 20 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 },
                ];
                for (let i in worksheet) {
                    if (typeof worksheet[i] != "object") continue;
                    let cell = xlsx.utils.decode_cell(i);
                    worksheet[i].s = {
                        font: {
                            name: "Calibri",
                            sz: 11,
                            color: { rgb: "000000" },
                        },
                        border: {
                            top: {
                                style: "thin",
                                color: { rgb: "000000" },
                            },
                            bottom: {
                                style: "thin",
                                color: { rgb: "000000" },
                            },
                            left: {
                                style: "thin",
                                color: { rgb: "000000" },
                            },
                            right: {
                                style: "thin",
                                color: { rgb: "000000" },
                            },
                        },
                    };

                    if (cell.r == 2) {
                        worksheet[i].s.font.bold = true;
                        worksheet[i].s.fill = {
                            patternType: "solid",
                            fgColor: { rgb: "DDDDDD" },
                        };
                    }
                    if (cell.r == 0) {
                        worksheet[i].s.font.bold = true;
                        worksheet[i].s.font.underline = true;
                        worksheet[i].s.font.sz = 12;
                        worksheet[i].s.fill = {
                            patternType: "solid",
                            fgColor: { rgb: "FFFFFF" },

                        };
                        worksheet[i].s.alignment = {
                            vertical: "center",
                                horizontal: "center",
                                wrapText: '1',
                        }
                    }
                }
                for (var i in worksheet) {
                    if (typeof worksheet[i] != 'object') continue;
                    let cell = xlsx.utils.decode_cell(i);
                    if (cell.c == 6) {
                        worksheet[i].z = 'dd-mmm-yyyy';
                    }
                }
                xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
                const excelBuffer: any = xlsx.write(workbook, {
                    bookType: "xlsx",
                    type: "array",
                });

                let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                //this.dataGrid.instance.clearFilter();
                this.clientData = this.clientDetailsForFilter;
                const data2: Blob = new Blob([excelBuffer], {
                    type: EXCEL_TYPE,
                });
                FileSaver.saveAs(data2,  [[this.clientSelectedType + " Clients List"]], { origin: "A1" });
                this.monitorService.logTrace("UI-exportClientListToExcel", { "exportClientListToExcel ": "Completed: " + this.msg + this.dateTime }, SeverityLevel.Information)
            });
        }
        catch (ex: any) {
            this.monitorService.logException(ex, 2);
        }
    }




    exportGrid(selectedItems = []) {
        this.monitorService.logEvent("exportGrid", { "exportGrid": "Start: " + this.msg + this.dateTime });
        try {
            this.dataGrid.instance.getDataSource()?.store()
            .load({ filter: this.dataGrid.instance.getCombinedFilter(true), sort: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.sort, group: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.group })
            .then((filteredData: any) => {
                this.head = [['Client Name', 'Primary Contact', 'Billing Contact', 'Technical Contact', 'Country', 'Active Projects', 'Onboarded on']];
                this.clientExcelDataArray = [];
                // let filterUsers = this.dataGrid.instance.getDataSource();
                // let filteredData = filterUsers.items();
                this.clientData = [];
                selectedItems.length == 0 ? this.clientData = filteredData :  this.clientData = selectedItems;
                let formattedDate;

                if (this.clientData.length > 0) {
                    this.clientData.forEach(x => {
                         this.data = [x.name, this.getPrimaryContact(x), this.getTechnicalContact(x), this.getBillingContact(x), x.country.name, x.projectCount, (x.orgnizationCreationDate).toFormat('dd/MM/yyyy').toLocaleString()];

                        this.clientExcelDataArray.push(this.data);
                    });


                    const doc = new jsPDF("l", "pt");
                    doc.setFontSize(18);
                    doc.text(this.clientSelectedType + ' Clients List', 40, 30);
                    //doc.text('C List', 11, 8);
                    doc.setFontSize(11);
                    doc.setTextColor(100);
                    (doc as any).autoTable({
                        head: this.head,
                        body: this.clientExcelDataArray,
                        theme: 'striped',
                        tableLineColor: [189, 195, 199],
                        startY: 40,
                        margin: {
                            top: 30
                        },
                        didDrawCell: data => {
                        }
                    });
                    this.clientData = this.clientDetailsForFilter;
                    doc.save(this.clientSelectedType + ' Clients List.pdf');
                }
                else {
                    this.clientData = this.clientDetailsForFilter;
                }

                this.monitorService.logEvent("exportGrid", { "exportGrid": "completed: " + this.msg + this.dateTime });
            });
        }
        catch (ex: any) {
            this.monitorService.logException(ex, 2);
        }
        //doc.save('Client List.pdf');
    }

    singleDeleteClient(id: number, myDrop) {
        this.singleDeleteid = id;
        this.singleDelete = true;
        this.appModaldeletePopup.show();
        myDrop.close();
    }
    onModalYesClick(id) {


        if (this.singleDelete) {
            this._clientServiceProxy.updateStatusProjectDelete(this.singleDeleteid).subscribe(() => {
                this.getAllClients();
                this.toastr.error(this.l("Deleted successfully"), '', { toastClass: 'custom-width-toastr'});
                //this.notify.success("Deleted Successfully", "Deleted !!");
                this.singleDelete = false;
            });
        }

        if (this.allowmultipledelete) {
            let temp: number[] = [];
            this.selectedClients.forEach(x => { temp.push(x.id) });
            this._clientServiceProxy.deleteClientByList(temp).subscribe(() => {
                this.getAllClients();
                 this.toastr.error(this.l("Deleted successfully"), '', {
      toastClass: 'custom-width-toastr'
    });
                //this.notify.success("Deleted Successfully", "Deleted !!");
                this.allowmultipledelete = false;
            });
        }
        if (this.singledeleteFromarchive) {
            this._clientServiceProxy.updateStatusProjectDelete(this.singledeleteFromarchiveId).subscribe(() => {
                this.getAllClients();
                this.toastr.error(this.l("Deleted successfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
                this.singledeleteFromarchive = false;
            });
        }
        if (this.recentclientdelete) {
            this._clientServiceProxy.delete(this.recentclientdeleteId).subscribe(() => {
                this.recendaryUpdateClient();
                this.getAllClients();
                this.recentclientdelete = false;
                this.toastr.error(this.l("Deleted successfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
            });
        }
        if (this.IsSinglePermanentDelete) {
            this._clientServiceProxy.permanantDeleteClientByList([this.singlePermanentDeleteId]).subscribe(() => {
                this.getAllClients();
                this.toastr.error(this.l("Deleted successfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
            });
        }

    }

    onModalCancelClick() {
    }



    getFullname(name: string, lastname: string) {
        return name + " " + lastname;
    }



    DisableTooltip(name: string, num: number) {
        return name?.length < num;
    }

    getPrimaryContact(client: ClientDto) {
        if (!client?.clientContacts?.length) return '-';
        const primaryContact = client.clientContacts.find(x => x.isPrimary);
        if (primaryContact) return _.capitalize(primaryContact.firstName + ' ') + _.capitalize(primaryContact.lastName)
        if (!primaryContact) return '-';

    }
    getSecondaryContact(client: ClientDto) {
        if (!client?.clientContacts?.length) return '-';
        const SeconadaryContact = client.clientContacts.find(x => x.isPrimary == false);
        if (SeconadaryContact) return _.capitalize(SeconadaryContact.firstName + ' ') + _.capitalize(SeconadaryContact.lastName)
        if (!SeconadaryContact) return '-';

    }

    getTechnicalContact(client: ClientDto) {
        if (client.contactDetails.clientContactRoleId === 1) {
            return this.getSecondaryContact(client);
        }
        if (client.contactDetails.clientContactRoleId === 2) {
            return this.getPrimaryContact(client);
        }
    }


    getBillingContact(client: ClientDto) {
        if (client.contactDetails.clientContactRoleId === 2) {
            return this.getSecondaryContact(client);
        }
        if (client.contactDetails.clientContactRoleId === 1) {
            return this.getPrimaryContact(client);
        }
    }


    getPrimaryEmail(client: ClientDto) {
        if (!client?.clientContacts?.length) return '-';
        const primaryContact = client.clientContacts.find(x => x.isPrimary);
        if (primaryContact) return primaryContact.email
        if (!primaryContact) return '-';
    }

    getSecondaryEmail(client: ClientDto) {
        if (!client?.clientContacts?.length) return '-';
        const secondaryContact = client.clientContacts.find(x => x.isPrimary == false);
        if (secondaryContact) return secondaryContact.email
        if (!secondaryContact) return '-';
    }


    onClickCard(event: string) {

        this._clientNameService.createCard(event);

    }
    ////devexpress
    searchbtn(event) {
        this.show = !this.show;
        if (!this.show) this.dataGrid.instance.clearFilter();
    }
    showVal(event: any) {

        this.selectedClients = [];
        const clientData = this.selectedClients.concat(event.selectedRowsData);
        this.selectedClients = clientData;
    }

    onContentReady(e: any) {
        var noData
        let filterUsers = this.dataGrid?.instance?.getDataSource();
        let filteredData = filterUsers?.items();
        if (filteredData?.length <= 0) {
            this.showClientExport = true;
        }
        else {
            this.showClientExport = false;
        }
        setTimeout(() => {
            noData = document.querySelector(".dx-datagrid-nodata");
            if (noData) {

                noData.innerHTML =
                    `  <div *ngIf="IsClientsDataEmpty" class="d-flex flex-column justify-content-center align-items-center px-4 pt-4 h-100">
 <img src="assets/common/images/client/clients-details/All Client.svg" class="w-100px mb-3 img_nodatafound" />
 <h6 class="my-3 text-muted text-center mt-2">${this.l('NoDataFound')}</h6>
</div> `
            }

        })

    }
    dateFormatDX = (arg) => (
        this.pipe.transform(arg, this.dateFormat)
    );


    onExportButtonChange(val: any) {
        switch (val) {
            case 1: // Export all data to PDF
                this.exportGrid();
                break;
            case 2: // Export selected data to PDF
                this.exportGrid(this.selectedClients);
                break;
            case 3: // Export all data to Excel
                this.exportClientListToExcel();
                break;
            case 4: // Export selected data to Excel
                this.exportClientListToExcel(this.selectedClients);
                break;
        }
    }



     // Handler to close side panel
     closeSidePanelNew() {
        this.isSidebarOpen = false;

    }
}
